import Utils from "../utils/utils";
import RequestManager from "./RequestManager";

const getAllEnvironmentsInDomain = async (domainId, size, firstCursor, lastCursor, prev, getLatest) => {
    const urlParams = Utils.getUrlParams({ size, prev, firstCursor, lastCursor, getLatest });

    const environments = await RequestManager.get({
        url: "/environment/domain/v1/" + domainId + urlParams
    });
    return environments.data;
};

const createEnvironment = async (body) => {
    const response = await RequestManager.post({
        url: "/environment/v1",
        body
    });
    return response;
};

const getEnvironment = async (id) => {
    const response = await RequestManager.get({
        url: "/environment/v1/" + id
    })
    return response;
};

const addTemplate = async (id, body) => {
    const response = await RequestManager.put({
        url: "/environment/addTemplate/v1/" + id,
        body
    });
    return response;
}

const updateEnvironment = async (id, body) => {
    const response = await RequestManager.put({
        url: "/environment/v1/" + id,
        body
    });
    return response;
}

const deleteEnvironment = async (id) => {
    const response = await RequestManager.del({
        url: "/environment/v1/" + id
    });
    return response;
};

const Environment = {
    addTemplate,
    getAllEnvironmentsInDomain,
    createEnvironment,
    getEnvironment,
    updateEnvironment,
    deleteEnvironment
};

export default Environment;